import { useContext, useEffect, useState } from "react";
import envVariables from "../data/envVariables";
import axios from "axios";
import AuthContext from "../store/AuthContext";
import { getMockResponse } from "../mockApi";

const useGet = (url, delay) => {
    // Auth context
    const authCtx = useContext(AuthContext);

    // State
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [returnData, setReturnData] = useState("");
    const [savedUrl, setSavedUrl] = useState("");

    useEffect(() => {
        if (url && url !== savedUrl) {
            setLoading(true);
            setReturnData(false);
            setSavedUrl(url);

            const mock = getMockResponse(url);

            if (mock) {
                setTimeout(() => {
                    setLoading(false);
                    setReturnData(mock.data);
                    setError(false);
                }, delay);

                return;
            }

            let config = {};

            if (authCtx.id) {
                config = {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${authCtx.token}`,
                    },
                };
            }

            axios
                .get(envVariables.apiEndpoint + url, config)
                .then((response) => {
                    setTimeout(() => {
                        if (response.status === 200 || response.status === 204) {
                            setLoading(false);
                            setReturnData(response.status === 204 ? [] : response.data);
                            setError(false);
                        } else {
                            setLoading(false);
                            setError(`There's been a problem on the server. Please refresh the page and try again.`);
                        }
                    }, delay);
                })
                .catch((error) => {
                    if (error) {
                        setLoading(false);
                        setError(`There's been a problem on the server. Please refresh the page and try again.`);
                    }
                });
        }
        // authCtx.id/token are read but the effect is gated by `url !== savedUrl`
        // so it only re-fetches when the URL changes, not on auth changes.
    }, [delay, savedUrl, url, authCtx.id, authCtx.token]);

    return {
        loading,
        error,
        returnData,
    };
};

export default useGet;
